"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayModal = exports.DISPLAY_MODAL = void 0;
/* ++++++++++ --------------- EXPORTS - MODAL - ACTIONS --------------- ++++++++++ */

var DISPLAY_MODAL = 'DISPLAY_MODAL';
exports.DISPLAY_MODAL = DISPLAY_MODAL;

var displayModal = function displayModal(isVisible, contentToDisplay, showCloseButton) {
  return {
    type: DISPLAY_MODAL,
    isVisible: isVisible,
    contentToDisplay: contentToDisplay,
    showCloseButton: showCloseButton
  };
};

exports.displayModal = displayModal;